"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _FilterDialog = _interopRequireWildcard(require("./FilterDialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StatusFilter = function StatusFilter(_ref) {
  var className = _ref.className,
      value = _ref.value,
      onChange = _ref.onChange;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      dialogActive = _useState2[0],
      setDialogActive = _useState2[1];

  var onSave = function onSave(selectedStatus) {
    setDialogActive(false);
    onChange(selectedStatus);
  };

  var clearStateFilter = function clearStateFilter(event) {
    event.stopPropagation();
    onChange(_FilterDialog.defaultState);
  };

  var activeFilterCount = Object.entries(value).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        isActive = _ref3[1];

    // filter information keys, because they are filter but not shown
    if (['CARRIER_INFORMATION', 'CBT_INFORMATION', 'TK_INFORMATION'].includes(key)) {
      return false;
    }

    return isActive;
  }).length;
  var hasFiltersSelected = activeFilterCount > 0;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    raised: true,
    onClick: function onClick() {
      return setDialogActive(true);
    },
    className: (0, _classnames["default"])('relative flex items-center', {
      'pr-2': hasFiltersSelected
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.addStateFilterButton"
  }), hasFiltersSelected && /*#__PURE__*/_react["default"].createElement("button", {
    tabIndex: 0,
    title: intl.formatMessage({
      id: 'filters.reset'
    }),
    className: "ml-1 cursor-pointer outline-none",
    onClick: clearStateFilter
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterClose, {
    className: "h-5 w-5 fill-primary"
  })), hasFiltersSelected && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute bottom-0 right-0 transform translate-x-1/2 translate-y-1/2 flex items-center justify-center border border-primary h-5 w-5 rounded-full font-bold text-sm text-primary bg-white"
  }, activeFilterCount)), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog, {
    active: dialogActive
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Header, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "filters.addStateFilterTitle"
    })
  }), /*#__PURE__*/_react["default"].createElement(_FilterDialog["default"], {
    selectedStatus: value,
    onCancel: function onCancel() {
      return setDialogActive(false);
    },
    onSave: onSave
  })));
};

StatusFilter.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].shape({}),
  onChange: _propTypes["default"].func
};

var noop = function noop() {};

StatusFilter.defaultProps = {
  className: '',
  value: {},
  onChange: noop
};
var _default = StatusFilter;
exports["default"] = _default;